module.exports = __webpack_public_path__ + "img/ywjs_06.2cbb4d7f.png";